import * as React from "react";
import Treatment from "../model/treatment/Treatment";
import TreatmentAssignment from "../model/treatment/TreatmentAssignment";

interface AssignedTreatmentViewerProps {
  assignment: TreatmentAssignment;
  onDelete?: (assignment: Treatment) => any;
}

export default class AssignedTreatmentViewer extends React.Component<AssignedTreatmentViewerProps> {
  render() {
    return (
      <div className={"label" + (this.props.assignment.isAutoAssigned ? " secondary" : "")}>
        <span>{this.props.assignment.treatment.name}</span>
        {this.props.onDelete && (
          <i
            className="ic_close clickable action"
            onClick={() => this.props.onDelete(this.props.assignment.treatment)}
          />
        )}
      </div>
    );
  }
}
